export const AuthEventTypes = {
  SignedIn: 'signed-in',
  SignedOut: 'signed-out',
  Unauthorized: 'unauthorized',
} as const;

export type AuthEventType =
  (typeof AuthEventTypes)[keyof typeof AuthEventTypes];

export interface AuthEvent {
  type: AuthEventType;
  createdAt: number;
}
